module.exports = __webpack_public_path__ + "static/media/131490897_718329725464381_5161286122015517040_n.84241788.jpg";